// Abstract moving horizons inspired by the user's Sierra Nevada setting.
// These are brand shapes, not a geographically literal mountain profile.
export const ridgeLayers = [
    // Draw from back/top to front/bottom. Positive direction travels right.
    { speed: .082, direction: -1, phase: .45, frequency: 1.28, level: .23, amplitude: .058, colors: ['#dfe0f3', '#d6d6ef', '#cccee8'] },
    { speed: .057, direction: 1, phase: 1.9, frequency: 1.36, level: .39, amplitude: .059, colors: ['#f9dab9', '#f8cc9e', '#f3d4b1'] },
    { speed: .071, direction: -1, phase: 3.2, frequency: 1.22, level: .55, amplitude: .057, colors: ['#e6ebdf', '#e0e6da', '#d6e0d0'] },
    { speed: .045, direction: 1, phase: 5.1, frequency: 1.31, level: .71, amplitude: .056, colors: ['#ede3cf', '#e6dac0', '#e0d4b9'] },
];
export function ridgeHeight(u, time, layer) {
    const l = ridgeLayers[layer];
    const theta = u * Math.PI * 2 * l.frequency - time * l.speed * l.direction + l.phase;
    // Locked harmonics preserve the shape as it travels. No competing phases
    // can cancel a crest or swell it into a blob. Fixed baselines keep bands open.
    return l.level + l.amplitude * (Math.sin(theta) + .12 * Math.sin(2 * theta + .25));
}
export function mountWave(root) {
    const canvas = root.querySelector('canvas');
    if (!canvas)
        return () => { };
    const ctx = canvas.getContext('2d');
    if (!ctx)
        return () => { };
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = true, frame = 0, last = 0, time = 0, width = 1, height = 1;
    const draw = () => {
        ctx.clearRect(0, 0, width, height);
        ridgeLayers.forEach((l, i) => {
            const gradient = ctx.createLinearGradient(0, 0, width, height * .6);
            l.colors.forEach((color, j) => gradient.addColorStop(j / 2, color));
            ctx.fillStyle = gradient;
            ctx.beginPath();
            for (let x = 0; x <= width + 3; x += 3) {
                const y = ridgeHeight(x / width, time, i) * height;
                if (x === 0)
                    ctx.moveTo(x, y);
                else
                    ctx.lineTo(x, y);
            }
            ctx.lineTo(width, height);
            ctx.lineTo(0, height);
            ctx.closePath();
            ctx.fill();
        });
        // One continuous soft landing into the page; no separate stripe or gap.
        ctx.globalCompositeOperation = 'destination-out';
        const fade = ctx.createLinearGradient(0, height * .81, 0, height);
        fade.addColorStop(0, 'rgba(0,0,0,0)');
        fade.addColorStop(1, 'rgba(0,0,0,1)');
        ctx.fillStyle = fade;
        ctx.fillRect(0, height * .81, width, height * .19);
        ctx.globalCompositeOperation = 'source-over';
    };
    const tick = (now) => { frame = 0; if (last)
        time += Math.min((now - last) / 1000, .05); last = now; draw(); if (!reduced.matches && visible && !document.hidden)
        frame = requestAnimationFrame(tick); };
    const sync = () => { cancelAnimationFrame(frame); frame = 0; last = 0; draw(); if (!reduced.matches && visible && !document.hidden)
        frame = requestAnimationFrame(tick); };
    const resize = () => { const box = root.getBoundingClientRect(); width = box.width; height = box.height; const dpr = Math.min(window.devicePixelRatio || 1, 2); canvas.width = Math.round(width * dpr); canvas.height = Math.round(height * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); draw(); };
    const observer = new ResizeObserver(resize);
    observer.observe(root);
    const intersection = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
    intersection.observe(root);
    reduced.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    resize();
    sync();
    return () => { cancelAnimationFrame(frame); observer.disconnect(); intersection.disconnect(); reduced.removeEventListener('change', sync); document.removeEventListener('visibilitychange', sync); };
}

const mounted=new Map();
function mountAll(){document.querySelectorAll('[data-obvs-wave]').forEach(root=>{if(!mounted.has(root))mounted.set(root,mountWave(root));});for(const [root,cleanup] of mounted){if(!root.isConnected){cleanup();mounted.delete(root);}}}
mountAll();
new MutationObserver(mountAll).observe(document.body,{childList:true,subtree:true});
document.addEventListener('shopify:section:load',mountAll);
